module.exports = "/assets/images/f1cc8a3750262489f38ac90821a06a06.jpg";